
    // @ts-nocheck
    import { __internal_buildRpcClient } from "@blitzjs/rpc";
    export default __internal_buildRpcClient({
      resolverName: "sendContactMessage",
      resolverType: "mutation",
      routePath: "/sendContactMessage",
      httpMethod: "POST",
    });
  